import * as api from '../apis/paycodes';
import { apiCall } from '~/lib/redux/api';
import { PaycodeAttemptActions, EntityActions } from './consts';
import { PaycodeNormalizer } from 'apps/sender/actions/normalize';
import { defaultTablePageSize } from '~/common/components/consts';


// TODO: Use constants
export function getPaycodeAttempList(offset: number = 0, limit: number = defaultTablePageSize) {
  return apiCall({
    actions: [
      PaycodeAttemptActions.LOAD_REQUEST,
      [EntityActions.ADD_ENTITIES, PaycodeAttemptActions.LOAD_LIST_SUCCESS],
      PaycodeAttemptActions.LOAD_ERROR,
    ],
    normalizer: [PaycodeNormalizer],
    fn: () => api.getPaycodesAttemp(offset, limit),
  });
}

export function createPaycodeAttemp(locationId, dataForm) {
  return apiCall({
    actions: [
      PaycodeAttemptActions.LOAD_REQUEST,
      [EntityActions.ADD_ENTITIES, PaycodeAttemptActions.LOAD_SUCCESS],
      PaycodeAttemptActions.LOAD_ERROR,
    ],
    normalizer: PaycodeNormalizer,
    fn: () => api.createPaycodeAttemp(locationId, dataForm),
  })
}

export function setPaycodeAttempCurrentPage(page: number) {
  return {
    type: PaycodeAttemptActions.SET_CURRENT_PAGE,
    currentPage: page,
  }
}
